"use client";

import {
  isServerActionNotFoundError,
  isUnexpectedResponseError,
} from "@/lib/serverActionUtils";

const RELOAD_KEY = "study-plan-request-reload";
const RELOAD_INTERVAL_MS = 60_000;

/**
 * 배포 교체/차단으로 Action 응답을 읽을 수 없으면 편집을 닫고 전체 페이지를 갱신한다.
 * 쓰기의 성공 여부는 알 수 없으므로 요청을 재전송하지 않고 DB를 다시 조회한다.
 * Vercel의 차단 응답에는 Next의 Action-not-found 헤더가 없을 수도 있다.
 */
export function recoverStudyPlanRequest(
  error: unknown,
  setLoadError: (message: string) => void,
): boolean {
  // Next 16은 text/plain 오류 본문을 그대로 Error.message에 넣는다.
  // HTML/빈 응답뿐 아니라 이 경로의 응답 형식 오류(E394)도 처리한다.
  const invalidActionResponse =
    error instanceof Error &&
    "__NEXT_ERROR_CODE" in error &&
    error.__NEXT_ERROR_CODE === "E394";
  if (
    !isServerActionNotFoundError(error) &&
    !isUnexpectedResponseError(error) &&
    !invalidActionResponse
  ) {
    return false;
  }

  setLoadError(
    "학습 일정 연결을 갱신해야 해요. 페이지를 새로고침해 저장된 일정을 확인해주세요.",
  );

  // 여러 위젯의 동시 실패와 새로고침 후 반복 실패 모두 자동 새로고침을 제한한다.
  // 저장소 접근이 차단된 브라우저에서는 수동 새로고침 안내를 유지한다.
  try {
    const now = Date.now();
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY));
    if (last && now - last < RELOAD_INTERVAL_MS) return true;
    window.sessionStorage.setItem(RELOAD_KEY, String(now));
  } catch {
    return true;
  }

  window.setTimeout(() => window.location.reload(), 1500);
  return true;
}
